export default {
  'app.pwa.offline': 'Вы сейчас офлайн',
  'app.pwa.serviceworker.updated': 'Доступно новое содержимое',
  'app.pwa.serviceworker.updated.hint':
    'Пожалуйста, нажмите кнопку "Обновить", чтобы перезагрузить текущую страницу',
  'app.pwa.serviceworker.updated.ok': 'Обновить',
  'app.updateCheck.title': 'Проверка обновлений',
  'app.updateCheck.backend': 'Бэкенд',
  'app.updateCheck.frontend': 'Фронтенд',
  'app.updateCheck.upToDate': 'Актуальная версия',
  'app.updateCheck.newVersionAvailable': 'Доступно {count} новое обновление',
  'app.updateCheck.allUpToDate': 'Все компоненты актуальны',
  'app.updateCheck.viewRelease': 'Посмотреть релиз',
  'app.updateCheck.recheck': 'Проверить снова',
  'app.updateCheck.close': 'Закрыть',
  'app.updateCheck.failed': 'Не удалось проверить обновления, попробуйте позже',
};
